import httpService from "./httpService";
import utils from "./utils";

export default {
  get() {
    return httpService.get("user", null);
  },

  update(id, form) {
    return httpService.put(`/user/${id}`, form);
  },

  save(form) {
    return httpService.post(`/user`, form);
  },

  delete(id) {
    return httpService.delete("/user/" + id);
  },

  findAll() {
    return httpService.get(`/user/findAll`);
  },

  findall(example, pageable) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge(example, pageable);
    return httpService.get(`/user/findAll`, { params: params });
  },

  findById(id) {
    return httpService.get("/user/" + id);
  },

  changeStatus(id, form) {
    return httpService.put(`/user/${id}/changeStatus`, form);
  },
  updateAvatar(data, id) {
    return httpService.post(`/user/${id}/updateAvatar`, data);
  },
};



// WEBPACK FOOTER //
// ./src/services/userService.js